<template>
  <div class="VRScene">
    <div id="container"></div>
  </div>
</template>
<script>
import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
export default {
  name: "VRScene",
  data() {
    return {
      img: require("../assets/pano.jpg"),
      camera: null,
      scene: null,
      renderer: null,
    };
  },
  mounted() {
    // this.camera
    // this.scene
    // this.renderer
    this.init();
    this.animate();
  },
  methods: {
    init() {
      var container, mesh;
      container = document.getElementById("container");
      this.camera = new THREE.PerspectiveCamera(
        65,
        window.innerWidth / window.innerHeight,
        1,
        1100
      );
      this.camera.target = new THREE.Vector3(0, 0, 0);
      this.scene = new THREE.Scene();
      var geometry = new THREE.SphereBufferGeometry(500, 40, 60);
      // var geometry = new THREE.SphereBufferGeometry( 100, 8, 8 );
      // invert the geometry on the x-axis so that all of the faces point inward
      geometry.scale(-1, 1, 1);
      let texture = new THREE.TextureLoader().load(this.img);
      this.material = new THREE.MeshBasicMaterial({ map: texture });
      this.material.needsUpdate = true;
      mesh = new THREE.Mesh(geometry, this.material);
      //   mesh.rotation.y = -Math.PI;
      mesh.rotation.x = -Math.PI;
      this.scene.add(mesh);

      this.renderer = new THREE.WebGLRenderer();
      this.renderer.setPixelRatio(window.devicePixelRatio);
      this.renderer.setSize(window.innerWidth, window.innerHeight);
      container.appendChild(this.renderer.domElement);

      this.controls = new OrbitControls(this.camera, this.renderer.domElement);

      //controls.update() must be called after any manual changes to the camera's transform
      this.camera.position.set(0, 20, 100);
      // this.camera.position.set(0, 10, 50);
      this.controls.update();

      window.addEventListener("resize", this.onWindowResize, false);
    },
    onWindowResize() {
      this.camera.aspect = window.innerWidth / window.innerHeight;
      this.camera.updateProjectionMatrix();
      this.renderer.setSize(window.innerWidth, window.innerHeight);
    },
    animate() {
      requestAnimationFrame(this.animate);
      this.controls.update();
      this.renderer.render(this.scene, this.camera);
    },
  },
};
</script>
<style scoped>
.VRScene .div {
  width: 100%;
  height: 100%;
  margin-top: 200px;
}
</style>